import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "approved",
  "use": "approved-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"approved\">\n    <path fill=\"#03ADEF\" fill-rule=\"evenodd\" d=\"M30.616 10.895L15.06 26.45v.001l-1.415 1.414v-.001.001l-1.414-1.414v-.001l-5.657-5.656L7.99 19.38l5.656 5.656L29.202 9.48l1.414 1.414z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol